var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgTonerA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#f9e6c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 144,
    height: 144
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,108A12,12,0,1,1,36,96,12.06,12.06,0,0,1,48,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,72A12,12,0,1,1,54,60,12.06,12.06,0,0,1,66,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102,72A12,12,0,1,1,90,60,12.06,12.06,0,0,1,102,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120,108a12,12,0,1,1-12-12A12.06,12.06,0,0,1,120,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84,108A12,12,0,1,1,72,96,12.06,12.06,0,0,1,84,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84,36A12,12,0,1,1,72,24,12.06,12.06,0,0,1,84,36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTonerA);
export default __webpack_public_path__ + "static/media/img_Toner_a.262f6f62b7cb81eeda628ed5dc4f295b.svg";
export { ForwardRef as ReactComponent };